// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {PLATFORMS} from './constants.js';

const client_strings = [
    {id: PLATFORMS.IOS, r: /(iPhone|iPad|iPod)/},
    {id: PLATFORMS.WINDOWS, r: /Win/},
    {id: PLATFORMS.MACOS, r: /Mac/},
    {id: PLATFORMS.LINUX, r: /(Linux|X11(?!.*CrOS))/},
    {id: PLATFORMS.ANDROID, r: /Android/},
];

const detect_platform = user_agent_str=>{
    let result;
    for (let {id, r} of client_strings)
    {
        if (r.test(user_agent_str))
        {
            result = id;
            break;
        }
    }
    return result || PLATFORMS.WINDOWS;
};

export const sort_links_by_platform = (a, b)=>{
    let platform = detect_platform(window.navigator.userAgent);
    if (platform == b.id)
        return 1;
    return -1;
};
